module.exports = __webpack_public_path__ + "img/img_throw_6@3x.a06459aa.png";